export default {
  form: {
    display_name: {
      label: 'Restaurantnavn',
      placeholder: 'Indtast restaurantnavn',
      help: 'Bruges på din kontrakt og dine fakturaer',
    },
    store_address: {
      label: 'Butiksadresse',
      placeholder: 'Søg efter din adresse',
      help: 'Dette er adressen, dine kunder ser',
    },
    address: {
      label: 'Adresse',
      placeholder: 'Gade + nummer',
    },
    zip_code: {
      label: 'Postnummer',
      placeholder: 'Postnummer',
    },
    city: {
      label: 'By',
      placeholder: 'By',
    },
    state: {
      label: 'Stat',
      placeholder: 'Vælg stat',
    },
    country: {
      label: 'Land',
      help: 'For at flytte din restaurant til et andet land, kontakt support',
    },
  },
  staff_notice:
    'Butikspersonale kan ikke bekræfte restaurantens navn og adresse. Bed venligst din onboarding manager om at tjekke disse oplysninger.',
  toasts: {
    saved: 'Butiksoplysninger gemt',
    error: 'Dine butiksoplysninger kunne ikke gemmes',
  },
  buttons: {
    next: 'Næste',
  },
};
